import React, { useState, useEffect } from 'react';
import { withStyles } from '@mui/styles';
import { WithStyles, StyleRules, ClassNameMap } from '@mui/material/styles/withStyles';
import { Theme } from '@mui/material/styles';
import { TextField, Grid, Typography } from "@mui/material";
import * as request from 'superagent';
import VerifiedUser from '@mui/icons-material/VerifiedUser';
import LoadingButton from '@mui/lab/LoadingButton';
import Popover from '@mui/material/Popover';
import ErrorView from '~common/components/error-view';


const styles = (theme: Theme): StyleRules => ({
  container: {
   width: "100%"
  },
  textField: {
    width: "100%"
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
  match: any;
}


const MFAAuthenticatorSetup: React.FC<Props & WithStyles<keyof typeof styles>> = (props) => {
  const { classes }: { classes: ClassNameMap } = props;

  const [error, setError] = useState(null);
  const [token, setToken] = useState(undefined);
  const [tokenVerifying, setTokenVerifying] = useState(false)
  const [invalidToken, setInvalidToken] = useState(undefined);
  const [anchorEl, setAnchorEl] = useState(undefined);
  const [showOTPSetupCode, setShowOTPSetupCode] = useState(undefined);

  const handleAPIError = (err: any) => {
    setError(err);
  };

  const onErrorClose = () => {
    setError(undefined);
  }

  const verifyOTP = () => {
    setTokenVerifying(true)
    request.put(`/api/auth/users/verify-otp-enroll/Authenticator`)
      .send({token: token, userName: props.userName})
      .then((response: request.Response) => {
        setTokenVerifying(false)
        if (!response.body.success) {
          setInvalidToken(true);
        } else {
          if (props.onSetupSuccess) {
            props.onSetupSuccess()
        } else {
            window.location.href = "/";
        }
        }
      })
      .catch((err) => {
        setTokenVerifying(false)
        handleAPIError(err);
      });
  };

  const hideOTPSetupKey = () => {
    setShowOTPSetupCode(false);
  };

  const showOTPSetupKey = () => {
    setShowOTPSetupCode(true);
  };

  const handleTokenChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    setInvalidToken(false);
    setToken(evt.target.value);
  };

  var errorView
  if (error) {
    errorView = <ErrorView error={error} classes={{}} onClose={onErrorClose} />
  }

  return (
    <div>
      {errorView}
       <Grid container spacing={8}>
            <Grid item className={classes.gridItem} xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography style={{ marginBottom: 10 }} variant="h6">
                    Before you start
                </Typography>
                <Typography style={{ marginBottom: 25 }} variant="body2">
                    Download a phone app like 1Password, Google Authenticator, LastPass Authenticator, etc. to get 2FA codes when prompted during log-in.
                </Typography>
                <Typography style={{ marginBottom: 10 }} variant="h6">
                    Scan the QR code
                </Typography>
                <Typography variant="body2">
                    Use an authenticator app from your phone to scan.
                </Typography>
                </Grid>

                  <Grid item className={classes.gridItem} xs={4} sm={4} md={4} lg={4} xl={4}>
                    <img
                      src={`data:image/png;base64, ${props.qr}`}
                      ref={(node) => {
                        setAnchorEl(node)
                      }}
                    />
                  </Grid>

                  <Grid item className={classes.gridItem} xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Typography variant="body2">
                      Unable to scan? Use this <span onClick={showOTPSetupKey} style={{ textDecoration: "underline", cursor: 'pointer' }}>setup code</span> to manually configure your authenticator app.
                    </Typography>

                    <Popover
                      id={"otpSecret"}
                      open={showOTPSetupCode}
                      anchorEl={anchorEl}
                      onClose={hideOTPSetupKey}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                    >
                      <Typography sx={{ p: 2 }}>{props.setupCode}</Typography>
                    </Popover>


                  </Grid>



                  <Grid item className={classes.gridItem} xs={12} sm={6} md={3} lg={3} xl={3}>
                    <TextField
                      error={invalidToken}
                      name="token"
                      label="One Time Password"
                      variant="standard"
                      className={classes.textField}
                      value={token || ''}
                      helperText={invalidToken ? "Invalid Code" : "Verify the code from the app"}
                      onChange={handleTokenChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />

                  </Grid>

                  <Grid item className={classes.gridItem} xs={4} sm={4} md={4} lg={4} xl={4}>
                    <LoadingButton
                      loading={tokenVerifying}
                      loadingPosition="end"
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      endIcon={<VerifiedUser />}
                      onClick={verifyOTP}
                  >
                      Verify
                  </LoadingButton>
                  </Grid>

        </Grid>
    </div>
  )
};

export default withStyles(styles)(MFAAuthenticatorSetup);